module.exports = __webpack_public_path__ + "img/Games-Room.443eb279.png";